import React from 'react';
const InfoIcon = () => {
    return (
        <svg
            width={20}
            height={20}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="10" cy="10" r="9" stroke="#344054" strokeWidth="2" />
            <rect x="9" y="6" width="2" height="7" fill="#344054" />
            <circle cx="10" cy="14.5" r="1" fill="#344054" />
        </svg>
    );
};

export default InfoIcon;
